import React, { useState, useEffect } from "react";
import getUsersByCondominio from "../../../../API/server/getusers";
import updateUser from "../../../../API/Manager/alterarUser";
import "../../../../styles/desktop/alterar.css";

export default function Alterar({ onBack }) {
    const [activeForm, setActiveForm] = useState("self");
    const [report, setReport] = useState({
        sindico: false,
        administrador: false,
        construtora: false,
        fornecedor: false,
    });
    const [showBackButton, setShowBackButton] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [oldName, setOldName] = useState("");

    const handleBackButtonClick = () => {
        setShowBackButton(false);
        setTimeout(() => onBack(), 300);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBackButton(true);
        }, 500); // Meio segundo (500ms)
    
        return () => clearTimeout(timer); // Limpa o timeout caso o componente seja desmontado
    }, []);
    

    useEffect(() => {
        if (activeForm === "others") {
            resetStatesToDefault();
            try {
                getUsersByCondominio().then((data) => {
                    if (data && data.users) {
                        setUsers(data.users);
                        console.log(data.users);
                    } else {
                        console.warn("Nenhum dado recebido da API.");
                    }
                });
            } catch (error) {
                console.error("Erro ao carregar usuários:", error);
            }
        }
    }, [activeForm]);

    useEffect(() => {
        if (activeForm === "self") {
            resetStatesToDefault();
            const storedUser = sessionStorage.getItem("user");
            if (storedUser) {
                const user = JSON.parse(storedUser);
                setUsername(user.name || "");
                setEmail(user.email || "");
            }
        }
    }, [activeForm]);

    useEffect(() => {
        if (selectedUser) {
            if (!oldName) {
                setOldName(selectedUser.name || ""); 
            }
        }
    }, [selectedUser, oldName]);
    
    const handlePermissionChange = (report) => {
        setReport((prev) => ({
            ...prev,
            [report]: !prev[report],
        }));
    };

    useEffect(() => {
        if (selectedUser && selectedUser.report) {
            setReport({
                sindico: selectedUser.report.sindico || false,
                administrador: selectedUser.report.administrador || false,
                construtora: selectedUser.report.construtora || false,
                fornecedor: selectedUser.report.fornecedor || false,
            });
        } else {
            // Reseta as permissões caso nenhum usuário esteja selecionado
            setReport({
                sindico: false,
                administrador: false,
                construtora: false,
                fornecedor: false,
            });
        }
        console.log(selectedUser);
    }, [selectedUser]);

    useEffect(() => {
        if (selectedUser) {
            setUsername(selectedUser.name || "");
            setEmail(selectedUser.email || "");
            setOldName(selectedUser.name || ""); // Armazena o nome antigo
        }
    }, [selectedUser]);
    
    
    const compararSenha = (senha) => {
        if(senha === document.getElementById("password").value) {
            setErrorMessage("");
            setNewPassword(senha);
        } else {
            setErrorMessage("As senhas não coincidem.");
        }
    }

    const resetStatesToDefault = () => {
        setUsers([]);
        setSelectedUser(null);
        setUsername("");
        setEmail("");
        setShowConfirmation(false);
        setIsSaving(false);
        setNewPassword("");
        setErrorMessage("");
    };

    const handleUserChange = (e) => {
        const userId = e.target.value;
        setSelectedUser(users.find((user) => user.id.toString() === userId));
    };

    const handleSaveChanges = () => {
        setShowConfirmation(true); // Exibe o pop-up de confirmação
    };

    const confirmSaveChanges = async () => {
        setIsSaving(true); // Exibe um estado de carregamento
        if(activeForm === "others") {
            try {
                const updatedData = {
                    oldName: oldName, // Nome antigo para a API
                    newName: username,
                    email: email,
                    report: report,
                };
        
                // Define o ID do usuário com base no formulário ativo
                const userId = activeForm === "self"
                    ? JSON.parse(sessionStorage.getItem("user")).id
                    : selectedUser.id;
        
                // Chama a função de atualização
                await updateUser(userId, updatedData);
        
                alert("Usuário atualizado com sucesso!");
        
                // Após salvar, busque novamente os usuários
                if (activeForm === "others") {
                    const updatedUsers = await getUsersByCondominio();
                    if (updatedUsers && updatedUsers.users) {
                        setUsers(updatedUsers.users);
                        console.log("Usuários atualizados:", updatedUsers.users);
                    } else {
                        console.warn("Nenhum dado recebido da API após a atualização.");
                    }
                }
            } catch (error) {
                console.error("Erro ao atualizar o usuário:", error);
                alert("Erro ao atualizar o usuário.");
            } finally {
                setIsSaving(false);
                setShowConfirmation(false); // Fecha o pop-up de confirmação
            }
        } else {
            if(newPassword === "") {
                alert("A senha não pode ser vazia.");
                setIsSaving(false);
                setShowConfirmation(false);
                return;
            }
            try {
                const updatedData = {
                    oldName: JSON.parse(sessionStorage.getItem("user")).name,
                    newName: username,
                    email: email,
                    password: newPassword,
                };
        
                // Define o ID e a tabela com base no formulário ativo
                const userId = activeForm === "self"
                    ? JSON.parse(sessionStorage.getItem("user")).id
                    : [];
                // Chama a função de atualização
                await updateUser(userId, updatedData);

                
        
                alert("Usuário atualizado com sucesso!");
                
            } catch (error) {
                console.error("Erro ao atualizar o usuário:", error);
                alert("Erro ao atualizar o usuário.");
            } finally {
                setIsSaving(false);
                setShowConfirmation(false); // Fecha o pop-up de confirmação
            }
        }
    };
    

    return (
        <div className="alterar-content-container">
            <div className="alterar-header">
                <h1 className="alterar-title">Alterar Dados</h1>

                <div className="alterar-form-toggle">
                    <div
                        className={`alterar-toggle-item ${activeForm === "self" ? "alterar-toggle-active" : ""}`}
                        onClick={() => setActiveForm("self")}
                    >
                        Editar Meu Usuário
                    </div>
                    <div
                        className={`alterar-toggle-item ${activeForm === "others" ? "alterar-toggle-active" : ""}`}
                        onClick={() => setActiveForm("others")}
                    >
                        Editar Outros Usuários
                    </div>
                </div>
            </div>

            {activeForm === "self" ? (
                <div className="alterar-form alterar-form-self">
                    <label className="alterar-label" htmlFor="username">Nome de Usuário:</label>
                    <input
                        className="alterar-input"
                        id="username"
                        name="username"
                        placeholder="Seu nome de usuário"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <label className="alterar-label" htmlFor="email">E-mail:</label>
                    <input
                        className="alterar-input"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Seu e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <label className="alterar-label">Nova Senha:</label>
                    <input
                        className="alterar-input"
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Nova senha"
                    />

                    {errorMessage && <p className="passwordErrorText">{errorMessage}</p>}

                    <label className="alterar-label">Confirmar Nova Senha:</label>
                    <input
                        className="alterar-input"
                        type="password"
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Confirme a nova senha"
                        onChange={(e) => compararSenha(e.target.value)}
                    />

                    <div className="alterar-submit-button" onClick={handleSaveChanges}>
                        Salvar Alterações
                    </div>
                </div>
            ) : (
                <div className="alterar-form alterar-form-others">
                    <label className="alterar-label" htmlFor="selectUser">Selecionar Usuário:</label>
                    <select
                        className="alterar-select"
                        id="selectUser"
                        name="selectUser"
                        onChange={handleUserChange}
                    >
                        <option value="">Selecione um usuário</option>
                        {users.map((user) => (
                            <option className="optionUsersAlterar" key={user.id} value={user.id}>
                                {user.name}
                            </option>
                        ))}
                    </select>

                    {selectedUser && (
                        <>
                            <label className="alterar-label" htmlFor="username">Nome de Usuário:</label>
                            <input
                                className="alterar-input"
                                name="username"
                                placeholder="Novo nome de usuário"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />

                            <label className="alterar-label" htmlFor="email">E-mail:</label>
                            <input
                                className="alterar-input"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Novo e-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />

                            <label className="alterar-label">Permissões de Reporte:</label>
                            <div className="alterar-checkbox-group">
                                {Object.keys(report).map((key) => (
                                    <label key={key}>
                                        <input
                                            type="checkbox"
                                            checked={report[key]}
                                            onChange={() => handlePermissionChange(key)}
                                        />
                                        {key.charAt(0).toUpperCase() + key.slice(1)}
                                    </label>
                                ))}
                            </div>
                        </>
                    )}

                    <div className="alterar-submit-button" onClick={handleSaveChanges}>
                        Salvar Alterações
                    </div>
                </div>
            )}

            {showBackButton && (
                <div className="alterar-back-button fade-in" onClick={handleBackButtonClick}>
                    Voltar
                </div>
            )}

            {showConfirmation && (
                <div className="confirmation-popup">
                    <p>Tem certeza que deseja salvar as alterações?</p>
                    <div className="popup-buttons">
                        <button onClick={confirmSaveChanges} disabled={isSaving}>
                            {isSaving ? "Salvando..." : "Sim"}
                        </button>
                        <button onClick={() => setShowConfirmation(false)} disabled={isSaving}>
                            Não
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
